function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-default",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iPhone-11",
  transform: "translate(-142.000000, -105.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "sms-2",
  transform: "translate(142.000000, 105.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "sms"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-20203",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1010"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1010"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u2731-/-Color-/-Icons-/-Black-/-Inactive",
  mask: "url(#mask-20203)",
  fill: "#ffffff",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.000000, -2.000000)",
  id: "Rectangle"
}))))), /*#__PURE__*/React.createElement("path", {
  d: "M18,0 L2,0 C0.9,0 0.01,0.9 0.01,2 L0,20 L4,16 L18,16 C19.1,16 20,15.1 20,14 L20,2 C20,0.9 19.1,0 18,0 Z M7,9 L5,9 L5,7 L7,7 L7,9 Z M11,9 L9,9 L9,7 L11,7 L11,9 Z M15,9 L13,9 L13,7 L15,7 L15,9 Z",
  id: "path-1010",
  fill: "white"
}));

function SvgSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.ea238b07.svg";
export { ForwardRef as ReactComponent };